import Joi from "joi";
import { EmailSchema, GenericNotEmptySchema } from "../helpers/JoiValidations";

export interface LoginDTO {
     email?: string;
     password?: string;
     recaptchaToken?: string | null;
}

export const LoginDTOSchema = Joi.object({
     email: EmailSchema(false),
     password: GenericNotEmptySchema("Password"),
     recaptchaToken: Joi.string().allow('').optional()
});